import { render, staticRenderFns } from "./LeaderboardView.vue?vue&type=template&id=570bb7a7&"
import script from "./LeaderboardView.vue?vue&type=script&lang=js&"
export * from "./LeaderboardView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports